module.exports = __webpack_public_path__ + "img/shaman.7e27aa6c.jpg";